module.exports = __webpack_public_path__ + "static/media/materiaPrima.b9cc1939.png";